export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6734.a0108875.jpg";